import i18next from 'i18next';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  broadcastId: Yup.string()
    .required(i18next.t('common.required'))
    .matches(/^\*[A-Z0-9]{7}$/, i18next.t('validation.threemaIdInvalid')),
  broadcastApiToken: Yup.string().required(i18next.t('validation.required.token')),
  validFrom: Yup.date(),
  validUntil: Yup.date().optional(),
});
